<template>
  <div id="app" :class="{ hasBar: showTitleBar, underWechat }">
    <title-bar-comp v-if="showTitleBar" class="global-title-bar" />

    <keep-alive>
      <router-view v-if="$route.meta && $route.meta.keepAlive" />
    </keep-alive>

    <router-view v-if="!$route.meta || !$route.meta.keepAlive" />
  </div>
</template>

<script>
import { BrowserUtil } from 'kuaidong-lib'
import { systemStore } from 'kuaidong-store'
import TitleBarComp from './components/global/TitleBar.vue'

export default {
  components: {
    TitleBarComp,
  },

  data() {
    return {
      underWechat: false,
    }
  },

  computed: {
    showTitleBar() {
      return systemStore.titleBarVisible
    },
  },

  async mounted() {
    this.underWechat = BrowserUtil.isWechat()
  },
}
</script>

<style lang="less">
#app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial,
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  box-sizing: border-box;
  margin: 0 auto;
  /**
   * iOS WKWebView 的 100vh 含主屏指示条，比可视区域高一截。
   * 检查作业等页把底栏钉在这块高度的底部，按钮会被裁出屏幕。
   * 100dvh 跟可视高度走；不支持的浏览器仍用 100vh。
   */
  height: 100vh;
  height: 100dvh;
  width: 100vmin;
  text-align: center;

  &.hasBar {
    padding-top: 52px;
  }

  &.disable-scroll {
    overflow: hidden;
  }
}
</style>
